import {
  ToggleButtonGroup,
  Box,
  Stack,
  Chip,
  ToggleButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const DepositGuiderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down(1000)]: {
    background: 'transparent',
    flexDirection: 'column',
  },
}));

export const StyledGuildLeft = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2), // 1是8px
  paddingTop: 0,
  width: '240px',
  flex: 'none',
  [theme.breakpoints.down(1000)]: {
    width: '100%',
    padding: 0,
  },
}));
export const StyledGuildRight = styled(Stack)(({ theme }) => ({
  flex: 1,
  paddingY: theme.spacing(2), // 1是8px
  paddingX: 0,
  flexDirection: 'row',
  alignItems: 'flex-end',
  height: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  [theme.breakpoints.down(1000)]: {
    padding: 0,
    width: '100%',
  },
}));
export const StyledRightItem = styled(Stack)(({ theme }) => ({
  position: 'relative',
  textAlign: 'center',
  flex: '1 1 auto',
  whiteSpace: 'nowrap',
  fontSize: '12px',
  minWidth: '23%',
  ['&.active']: {
    transform: 'translateY(-16px)',
    ['.arrow']: {
      top: '45% !important',
    },
  },
}));

export const StyledStageMobile = styled(Box)<{ step: number }>(
  ({ theme, step }) => ({
    position: 'relative',
    height: theme.spacing(13),
    paddingTop: theme.spacing(4.5),
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(/assets/images/promotion/bgm${step}.png)`,
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    paddingLeft: '25%',
    ['.bouns_amount']: {
      marginBottom: 0,
      marginLeft: '20px',
    },
  }),
);

export const StyledStage = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',

  ['.bg']: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
  },
  ['.bg1']: {
    backgroundImage: 'url(/assets/images/promotion/bg1.png)',
  },
  ['.bg2']: {
    backgroundImage: 'url(/assets/images/promotion/bg2.png)',
  },
  ['.bg3']: {
    backgroundImage: 'url(/assets/images/promotion/bg3.png)',
  },
  ['.bg4']: {
    backgroundImage: 'url(/assets/images/promotion/bg4.png)',
  },
}));

export const StyledDepositLabel = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  marginTop: '20px',
  marginBottom: '10px',
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    // 样式可以根据您的需求进行调整
    '& .MuiToggleButtonGroup-grouped': {
      border: 0,
      '&.Mui-selected': {
        backgroundColor: '#2e2f35',
        color: 'white',
        '&:hover': {
          backgroundColor: '#2e2f35',
        },
      },
      borderRadius: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      flex: 1,
      '& .MuiToggleButtonGroup-grouped': {
        flex: 1,
      },
    },
  }),
);
export const StyledToggleButton = styled(ToggleButton)(
  ({ theme, selected }) => ({
    // 如果按钮是选中状态
    ...(selected && {
      backgroundColor: '#2e2f35 ', // 选中按钮的背景色
    }),
    '&.MuiToggleButton-root': {
      borderRadius: '4px',
      color: '#848E9C',
      width: '150px',
      marginLeft: theme.spacing(0.125),
      marginRight: theme.spacing(0.125),
    },
  }),
);

export const BoxChip = styled(Chip)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.bg.hover,
  cursor: 'pointer',
  '& .MuiChip-label': {
    padding: theme.spacing(0.5, 1),
    color: '#0ECB81',
  },
}));

export const ArrowStep = styled(Box)(({ theme }) => ({
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  position: 'absolute',
  right: '-20px',
  top: '36%',
  '&.arrow1': {
    backgroundImage: 'url(/assets/images/promotion/stage_arrow.png)',
  },
  '&.arrow2': {
    backgroundImage: 'url(/assets/images/promotion/stage_arrow1.png)',
  },
  '&.arrow3': {
    backgroundImage: 'url(/assets/images/promotion/stage_arrow2.png)',
  },
}));

export const StyledStepBonus = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 10,
}));


export const StyledPageWrapper = styled(Stack)(({ theme }) => ({
  maxWidth: '820px',
  margin: '0 auto',
  gap: '20px',
  marginTop: theme.spacing(2),
  ['ol, ul']: {
    paddingInlineStart: '1em',
  },
  ['a']: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));
